export const FORM_STATES = {
	LOADING: Symbol('LOADING'),
	FORM: Symbol('FORM'),
	SUCCESS: Symbol('SUCCESS'),
	ERROR: Symbol('ERROR')
};
